import React, { Component } from 'react';
import { DatePicker, SelectField, DialogContainer, Button, TextField } from 'react-md';
import moment from 'moment';

import LocalDataManager from '../managers/LocalDataManager';

import ReportingService from '../services/ReportingService';

import ZMultiSelector from './Utility/ZMultiSelector';
import ZSingleSelector from './Utility/ZSingleSelector';

import ReportingTopBar from './Reporting/ReportingTopBar';
import ReportingViewCentral from './Reporting/ReportingViewCentral';

export default class GroupPage extends Component {
    constructor(props) {
        super(props);

        window.zzActiveObject = this;

        this.dbm = new LocalDataManager();

        this.reportingService = new ReportingService();

        this.state = {
            accountInfo: undefined,
            mode: "reportList",
            reportList: [],
            activeReport: null,
            newRunForm: null,
            newRunFinisherForm: null,
            newPhase: 0,
            emailDeleteIndex: null,
            rerunPhase: 0,
            rerunForm: null,
            genericSelectorJsx: null
        }

        this.userTypeHistory = [];
        this.emailKeyIncrementor = 0;

        this.init = this.init.bind(this);

        this.pollReport = this.pollReport.bind(this);

        this.back = this.back.bind(this);

        this.openReport = this.openReport.bind(this);
        this.popNewReport = this.popNewReport.bind(this);
        this.editNewRunForm = this.editNewRunForm.bind(this);
        this.toggleAllNewRunForm = this.toggleAllNewRunForm.bind(this);
        this.editNewRunFormDate = this.editNewRunFormDate.bind(this);
        this.editNewRunFinisherForm = this.editNewRunFinisherForm.bind(this);
        this.editNewRunFinisherFormEmail = this.editNewRunFinisherFormEmail.bind(this);
        this.addFinisherEmail = this.addFinisherEmail.bind(this);
        this.removeFinisherEmail = this.removeFinisherEmail.bind(this);
        this.editRerunForm = this.editRerunForm.bind(this);
        this.editRerunFormEmail = this.editRerunFormEmail.bind(this);
        this.addRerunEmail = this.addRerunEmail.bind(this);
        this.removeRerunEmail = this.removeRerunEmail.bind(this);
        this.toggleAllNewRunFinisherForm = this.toggleAllNewRunFinisherForm.bind(this);
        this.goToNewRunFinisher = this.goToNewRunFinisher.bind(this);
        this.submitForm = this.submitForm.bind(this);
        this.popRerunForm = this.popRerunForm.bind(this);
        this.submitRerunForm = this.submitRerunForm.bind(this);

        this.showRunInfo = this.showRunInfo.bind(this);
        this.deleteRun = this.deleteRun.bind(this);

        this.generateNewRunForm = this.generateNewRunForm.bind(this);

        this.openDownloadLink = this.openDownloadLink.bind(this);

        this.setGenericSelectorJsx = this.setGenericSelectorJsx.bind(this);

        let self = this;
        self.props.superInit(self.init, undefined, undefined, undefined);
    }

    init() {
        let self = this;

        self.dbm.getAccountInfo().then((accountInfo) => {
            
            if(accountInfo.isDashboardOnly)
            {
                self.props.changePage('login', false);
                return;
            }
            self.setState({ accountInfo: accountInfo }, () => {
                self.reportingService.getList(accountInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].companyID, reportList => {
                    self.setState({ reportList: reportList }, () => {
                        self.props.loadingOff();
                        setInterval(() => {
                            self.pollReport();
                        }, 10000)
                    });
                }, err => {
                    self.props.loadingOff();
                })
            });
        });
    }

    pollReport() {
        let self = this;
        if (self.state.activeReport != null) {
            let report = self.state.activeReport;
            self.reportingService.getRuns(
                report.reportId,
                self.state.accountInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].companyID,
                runs => {
                    report.runs = runs;
                    self.setState({ activeReport: report });
                }, err => {
                });
        }
    }

    back() {
        this.setState({ mode: "reportList", activeReport: null });
    }

    openReport(report) {
        let self = this;

        self.props.loadingOn();
        self.reportingService.getMetadata(report.reportId, reportMetadataJson => {
            self.reportingService.getRuns(
                report.reportId,
                self.state.accountInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].companyID,
                runs => {
                    try {
                        let reportMetadata = JSON.parse(reportMetadataJson);
                        let finalFunction = () => {

                            report.metaData = reportMetadata;
                            report.runs = runs;

                            report.metaDataReverseMap = reportMetadata.reduce((r, e) => {
                                let key = e.Name;
                                if (!r[key]) {
                                    let optionsList = e.JsonData != undefined && e.JsonData != null ?
                                        e.JsonData.reduce((nr, ne) => { nr.push({ key: ne.Key, value: ne.Value }); return nr; }, []) :
                                        e.GenericGetResults != undefined && e.GenericGetResults != null ? e.GenericGetResults : null;
                                    if (optionsList != null) {
                                        r[key] = optionsList.reduce((nr, ne) => {
                                            nr[ne.value] = ne.key;
                                            return nr;
                                        }, {});
                                    }
                                }

                                return r;
                            }, {});

                            self.setState({ mode: "report", activeReport: report }, () => {
                                self.props.loadingOff();
                            });
                        }

                        let genericGetCounter = 0;
                        reportMetadata.forEach(meta => {
                            if (meta.JsonData != undefined) {
                                let jsonBuilder = "";
                                let inObject = false;
                                for (var i = 0; i < meta.JsonData.length; i++) {
                                    if (meta.JsonData[i] === ":") {
                                        jsonBuilder += '"';
                                    }
                                    if (meta.JsonData[i] === "'") {
                                        jsonBuilder += '"';
                                    } else {
                                        jsonBuilder += meta.JsonData[i];
                                    }
                                    if (meta.JsonData[i] === "{") {
                                        jsonBuilder += '"';
                                        inObject = true;
                                    }
                                    if (meta.JsonData[i] === "}") {
                                        inObject = false;
                                    }
                                    if (inObject && meta.JsonData[i] === ",") {
                                        jsonBuilder += '"';
                                    }
                                }
                                meta.JsonData = JSON.parse(jsonBuilder);
                            }

                            if (meta.GetDataUri != undefined) {
                                genericGetCounter++;
                            }
                        });

                        if (genericGetCounter === 0) {
                            finalFunction();
                        } else {
                            reportMetadata.forEach(meta => {
                                if (meta.GetDataUri != undefined) {

                                    let uriBuilder = meta.GetDataUri;
                                    if (uriBuilder === "GetStoreList") {
                                        uriBuilder += "/" + self.state.accountInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].clientAccountId
                                    } else {
                                        uriBuilder += "/" + self.state.accountInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].clientAccountId
                                    }

                                    self.reportingService.genericGet(uriBuilder, result => {
                                        if (meta.IgnoreSort === undefined || meta.IgnoreSort === null || meta.IgnoreSort != "True") {
                                            meta.GenericGetResults = _.sortBy(result, x => x.key.toUpperCase().trim());
                                        } else {
                                            meta.GenericGetResults = result;
                                        }
                                        genericGetCounter--;
                                        if (genericGetCounter === 0) {
                                            finalFunction();
                                        }
                                    }, err => {
                                        alert("There was an error getting your data. Please try again.");
                                        self.props.loadingOff();
                                    });
                                }
                            });
                        }

                    } catch (ex) {
                        alert("An error occurred while loading report data. Please try again.");
                        self.props.loadingOff();
                    }
                }, err => {
                    alert("An error occurred while loading report data. Please try again.");
                    self.props.loadingOff();
                });
        }, err => {
            alert("An error occurred while loading report data. Please try again.");
            self.props.loadingOff();
        });
    }

    popNewReport() {
        let self = this;

        if (self.state.activeReport != null) {

            let report = self.state.activeReport;
            let newRunForm = {};

            report.metaData.forEach(meta => {
                newRunForm[meta.Name] = "";
                if (meta.Default != undefined) {
                    newRunForm[meta.Name] = meta.Default;
                }
                if (meta.FieldType === "DateTime") {

                    let todayDate = new Date();
                    todayDate.setHours(12);
                    newRunForm[meta.Name] = moment(todayDate).format("MM/DD/YYYY");
                } else if (meta.FieldType === "MultiSelect") {
                    newRunForm[meta.Name] = [];
                    if (meta.Default != undefined) {
                        if (meta.Default === "*") {
                            let tmpValList = meta.JsonData === undefined ? [] : meta.JsonData.reduce((r, e) => { r.push(e.Value); return r; }, [])
                            newRunForm[meta.Name] = tmpValList;
                        } else {
                            newRunForm[meta.Name] = [meta.Default];
                        }
                    }
                }
            });

            // New to default selected to all
            let locationMenuItems = [];
            this.state.accountInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].locations.forEach(loc => {
                if (loc.status.statusId === 1) {
                    locationMenuItems.push(loc.locationID);
                }
            });
            locationMenuItems = _.sortBy(locationMenuItems, x => x.toUpperCase().trim());

            let newRunFinisherForm = {
                filterJson: null,
                reportId: this.state.activeReport.reportId,
                expireDate: "1 Week",
                includePasswordInEmail: false,
                password: "",
                sendToEmails: [{ key: "email-no-" + (++this.emailKeyIncrementor), value: "" }],
                userTypeId: this.state.accountInfo.userType,
                clientAccountId: this.state.accountInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].clientAccountId,
                locationIds: locationMenuItems,
                exportType: null,
                reportFilter: null,
            }

            self.setState({ newRunForm: newRunForm, newRunFinisherForm: newRunFinisherForm, newPhase: 1 });
        }
    }

    editNewRunForm(metaData, value) {
        let newRunForm = this.state.newRunForm;

        if (typeof newRunForm[metaData.Name] === "object" && newRunForm[metaData.Name].length != undefined) {
            let found = false;
            for (var i = 0; i < newRunForm[metaData.Name].length; i++) {
                if (newRunForm[metaData.Name][i] === value) {
                    newRunForm[metaData.Name].splice(i, 1);
                    found = true;
                    break;
                }
            }
            if (!found) {
                newRunForm[metaData.Name].push(value);
            }
        } else {
            newRunForm[metaData.Name] = value;
        }

        this.setState({ newRunForm: newRunForm });
    }

    toggleAllNewRunForm(property, menuItems, callback) {
        let newRunForm = this.state.newRunForm;

        if (newRunForm[property].length === menuItems.length) {
            newRunForm[property] = [];
        } else {
            newRunForm[property] = menuItems.map(x => x.value);
        }

        this.setState({ newRunForm: newRunForm }, () => {
            if (callback && typeof callback === "function") {
                callback();
            }
        });
    }

    editNewRunFormDate(metaData, dateString, dateObject) {
        let newRunForm = this.state.newRunForm;

        newRunForm[metaData.Name] = moment(dateObject).format("MM/DD/YYYY");

        this.setState({ newRunForm: newRunForm });
    }

    editNewRunFinisherForm(property, value) {
        let newRunFinisherForm = this.state.newRunFinisherForm;

        if (typeof newRunFinisherForm[property] === "object" && newRunFinisherForm[property].length != undefined) {
            let found = false;
            for (var i = 0; i < newRunFinisherForm[property].length; i++) {
                if (newRunFinisherForm[property][i] === value) {
                    newRunFinisherForm[property].splice(i, 1);
                    found = true;
                    break;
                }
            }
            if (!found) {
                newRunFinisherForm[property].push(value);
            }
        } else {
            newRunFinisherForm[property] = value;

            if (property === "userTypeId") {
                this.userTypeHistory.push(value);
                if (this.userTypeHistory.length > 5) {
                    this.userTypeHistory.splice(0, 1);
                }
                if (this.userTypeHistory.length === 5 && 5 === this.userTypeHistory.reduce((r, e) => { return r + e }, 0)) {
                    newRunFinisherForm[property] = 0;
                    this.userTypeHistory = [];
                }
            }

            if (property === "password") {
                newRunFinisherForm[property] = value.trim();
            }
        }

        this.setState({ newRunFinisherForm: newRunFinisherForm });
    }

    editNewRunFinisherFormEmail(index, value) {
        let newRunFinisherForm = this.state.newRunFinisherForm;

        if (index < newRunFinisherForm.sendToEmails.length) {
            newRunFinisherForm.sendToEmails[index].value = value.trim().replace(/;|,/g, '');

            this.setState({ newRunFinisherForm: newRunFinisherForm });
        }
    }

    addFinisherEmail() {
        let newRunFinisherForm = this.state.newRunFinisherForm;

        newRunFinisherForm.sendToEmails.push({ key: "email-no-" + (++this.emailKeyIncrementor), value: "" });

        this.setState({ newRunFinisherForm: newRunFinisherForm }, () => {
            $(".md-dialog-content").animate({ scrollTop: $(".md-dialog-content").height() }, 1000);
        });
    }

    removeFinisherEmail(index) {
        let self = this;
        if (self.state.emailDeleteIndex === null) {
            self.setState({ emailDeleteIndex: index }, () => {
                setTimeout(() => {
                    let newRunFinisherForm = self.state.newRunFinisherForm;

                    if (index < newRunFinisherForm.sendToEmails.length) {
                        newRunFinisherForm.sendToEmails.splice(index, 1);

                        self.setState({ newRunFinisherForm: newRunFinisherForm, emailDeleteIndex: null });
                    } else {
                        self.setState({ emailDeleteIndex: null })
                    }
                }, 250);
            });
        }
    }

    editRerunForm(property, value) {
        let rerunForm = this.state.rerunForm;

        if (typeof rerunForm[property] === "object" && rerunForm[property].length != undefined) {
            let found = false;
            for (var i = 0; i < rerunForm[property].length; i++) {
                if (rerunForm[property][i] === value) {
                    rerunForm[property].splice(i, 1);
                    found = true;
                    break;
                }
            }
            if (!found) {
                rerunForm[property].push(value);
            }
        } else {
            rerunForm[property] = value;

            if (property === "userTypeId") {
                this.userTypeHistory.push(value);
                if (this.userTypeHistory.length > 5) {
                    this.userTypeHistory.splice(0, 1);
                }
                if (this.userTypeHistory.length === 5 && 5 === this.userTypeHistory.reduce((r, e) => { return r + e }, 0)) {
                    rerunForm[property] = 0;
                    this.userTypeHistory = [];
                }
            }

            if (property === "password") {
                rerunForm[property] = value.trim();
            }
        }

        this.setState({ rerunForm: rerunForm });
    }

    editRerunFormEmail(index, value) {
        let rerunForm = this.state.rerunForm;

        if (index < rerunForm.sendToEmails.length) {
            rerunForm.sendToEmails[index].value = value.trim().replace(/;|,/g, '');

            this.setState({ rerunForm: rerunForm });
        }
    }

    addRerunEmail() {
        let rerunForm = this.state.rerunForm;

        rerunForm.sendToEmails.push({ key: "email-no-" + (++this.emailKeyIncrementor), value: "" });

        this.setState({ rerunForm: rerunForm }, () => {
            $(".md-dialog-content").animate({ scrollTop: $(".md-dialog-content").height() }, 1000);
        });
    }

    removeRerunEmail(index) {
        let self = this;
        if (self.state.emailDeleteIndex === null) {
            self.setState({ emailDeleteIndex: index }, () => {
                setTimeout(() => {
                    let rerunForm = self.state.rerunForm;

                    if (index < rerunForm.sendToEmails.length) {
                        rerunForm.sendToEmails.splice(index, 1);

                        self.setState({ rerunForm: rerunForm, emailDeleteIndex: null });
                    } else {
                        self.setState({ emailDeleteIndex: null })
                    }
                }, 250);
            });
        }
    }

    toggleAllNewRunFinisherForm(property, menuItems, callback) {
        let newRunFinisherForm = this.state.newRunFinisherForm;

        if (newRunFinisherForm[property].length === menuItems.length) {
            newRunFinisherForm[property] = [];
        } else {
            newRunFinisherForm[property] = menuItems.map(x => x.value);
        }

        this.setState({ newRunFinisherForm: newRunFinisherForm }, () => {
            if (callback && typeof callback === "function") {
                callback();
            }
        });
    }

    goToNewRunFinisher() {
        let canProceed = true;

        let metaData = this.state.activeReport.metaData;
        for (var i = 0; i < metaData.length; i++) {
            let meta = metaData[i];
            if (meta.IsRequired.toLowerCase() === "true") {
                let formPiece = this.state.newRunForm[meta.Name];
                if (typeof formPiece === "string") {
                    if (formPiece === undefined || formPiece === null || formPiece === "") {
                        alert("Missing required field: " + meta.Name);
                        canProceed = false;
                        break;
                    }
                } else if (typeof formPiece === "object") {
                    if (formPiece === undefined && formPiece === null && formPiece.length === undefined || formPiece.length === 0) {
                        alert("Missing required field: " + meta.Name);
                        canProceed = false;
                        break;
                    }
                }
            }
        }

        if (canProceed) {
            this.setState({ newPhase: 2 });
        }
    }

    submitForm() {
        this.props.loadingOn();
        let newRunForm = this.state.newRunForm;
        let newRunFinisherForm = this.state.newRunFinisherForm;

        let tmpReportExportType = newRunForm.ReportExportType;
        if (typeof newRunForm.ReportExportType === "string") {
            if (newRunForm.ReportExportType.toUpperCase() === "EXCEL") {
                newRunForm.ReportExportType = 0;
            } else if (newRunForm.ReportExportType.toUpperCase() === "PDF") {
                newRunForm.ReportExportType = 1;
            }
        }

        let expireDate = new Date();
        switch (newRunFinisherForm.expireDate) {
            case "1 Day": ; expireDate.setDate(expireDate.getDate() + 1); break;
            case "1 Week": ; expireDate.setDate(expireDate.getDate() + 7); break;
            case "2 Weeks": ; expireDate.setDate(expireDate.getDate() + 14); break;
            case "1 Month": ; expireDate.setDate(expireDate.getDate() + 30); break;
            case "3 Months": ; expireDate.setDate(expireDate.getDate() + 90); break;
            case "6 Months": ; expireDate.setDate(expireDate.getDate() + 180); break;
            case "1 Year": ; expireDate.setDate(expireDate.getDate() + 365); break;
        }
        expireDate = moment(expireDate).format("MM/DD/YYYY");

        let sendToEmails = newRunFinisherForm.sendToEmails.map(x => x.value).join(";");

        let payload = {
            reportId: newRunFinisherForm.reportId,
            expireDate: expireDate,
            includePasswordInEmail: newRunFinisherForm.includePasswordInEmail,
            password: newRunFinisherForm.password.trim() === "" ? null : newRunFinisherForm.password.trim(),
            sendToEmails: sendToEmails,
            userTypeId: newRunFinisherForm.userTypeId,
            clientAccountId: newRunFinisherForm.clientAccountId,
            locationIds: newRunFinisherForm.locationIds,
            exportType: tmpReportExportType === undefined ? "Excel" : tmpReportExportType,
            reportFilter: JSON.stringify(newRunForm)
        };

        let report = this.state.activeReport;
        let self = this;
        self.reportingService.run(payload, (res) => {
            self.reportingService.getRuns(
                report.reportId,
                self.state.accountInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].companyID,
                runs => {
                    report.runs = runs;
                    self.setState({ activeReport: report, newRunForm: null, newRunFinisherForm: null, newPhase: 0, emailDeleteIndex: null }, () => {
                        self.props.loadingOff();
                    });
                }, err => {
                    alert("There was an error processing your request. Please try again.");
                    self.props.loadingOff();
                });
        }, err => {
            alert("There was an error processing your request. Please try again.");
            self.props.loadingOff();
        });
    }

    popRerunForm(run) {

        window.hideAlert();

        let rerunForm = {
            reportRunId: run.reportRunId,
            reportId: null,
            expireDate: "1 Week",
            includePasswordInEmail: false,
            password: "",
            sendToEmails: [{ key: "email-no-" + (++this.emailKeyIncrementor), value: "" }],
            userTypeId: null,
            clientAccountId: null,
            locationIds: null,
            exportType: null,
            reportFilter: null,
        }

        this.setState({ rerunPhase: 1, rerunForm: rerunForm })
    }

    submitRerunForm() {
        this.props.loadingOn();
        let rerunForm = this.state.rerunForm;

        let expireDate = new Date();
        switch (rerunForm.expireDate) {
            case "1 Day": ; expireDate.setDate(expireDate.getDate() + 1); break;
            case "1 Week": ; expireDate.setDate(expireDate.getDate() + 7); break;
            case "2 Weeks": ; expireDate.setDate(expireDate.getDate() + 14); break;
            case "1 Month": ; expireDate.setDate(expireDate.getDate() + 30); break;
            case "3 Months": ; expireDate.setDate(expireDate.getDate() + 90); break;
            case "6 Months": ; expireDate.setDate(expireDate.getDate() + 180); break;
            case "1 Year": ; expireDate.setDate(expireDate.getDate() + 365); break;
        }
        expireDate = moment(expireDate).format("MM/DD/YYYY");

        let sendToEmails = rerunForm.sendToEmails.map(x => x.value).join(";");

        let payload = {
            reportRunId: rerunForm.reportRunId,
            reportId: null,
            expireDate: expireDate,
            includePasswordInEmail: rerunForm.includePasswordInEmail,
            password: rerunForm.password.trim() === "" ? null : rerunForm.password.trim(),
            sendToEmails: sendToEmails,
            userTypeId: null,
            clientAccountId: null,
            locationIds: null,
            exportType: null,
            reportFilter: null
        };

        let report = this.state.activeReport;
        let self = this;
        self.reportingService.reRun(payload, res => {
            self.reportingService.getRuns(
                report.reportId,
                self.state.accountInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].companyID,
                runs => {
                    report.runs = runs;
                    self.setState({ activeReport: report, rerunForm: null, rerunPhase: 0, emailDeleteIndex: null }, () => {
                        self.props.loadingOff();
                    });
                }, err => {
                    alert("Could not reload reports")
                    self.props.loadingOff();
                });
        }, err => {
            alert("Unable to process rerun request. Please try again.")
            self.props.loadingOff();
        })
    }

    showRunInfo(run) {

        let runTitle = moment(moment.utc(run.createDate).local()).format("MM/DD/YYYY hh:mm A");
        let runExpires = moment(run.expireDate).format("MM/DD/YYYY");

        let runType = "";
        if (run.exportType === "XLSX" || run.exportType.toLowerCase() === "excel") {
            runType = "Excel";
        } else if (run.exportType === "PDF") {
            runType = "PDF";
        }

        let runStatus = "";
        switch (run.status) {
            case "Pending": runStatus = "Pending"; break;
            case "Completed": runStatus = "Complete"; break;
            case "Error": runStatus = "Error"; break;
            case "Expired": runStatus = "Expired"; break;
            case "In Progress": runStatus = "In Progress"; break;
            case "Archived": runStatus = "Archived"; break;
            case "Test": runStatus = "Test"; break;
            case "test": runStatus = "Test"; break;
        }

        let emailJsx = null;
        if (run.sendToEmails != null && run.sendToEmails != "") {
            let emailListJsx = [];
            emailListJsx.push((<div className={"title bordered-top"}>{"Sent To:"}</div>))
            run.sendToEmails.split(";").forEach(email => {
                emailListJsx.push((
                    <div className={"email"}>{email}</div>
                ));
            });
            emailJsx = (
                <div className={"email-list-outer"}>{emailListJsx}</div>
            )
        }

        alert((
            <div className={"report-run-info-alert"}>
                <div className={"title"}>{runTitle}</div>
                <div className={"title"}>{(runStatus === "Expired" ? "Expired" : "Expires") + " On: " + runExpires}</div>
                <div className={"title"}>{"Status: " + runStatus}</div>
                <div className={"title"}>{"Type: " + runType}</div>
                <div className={"title bordered"}>{"Password Protected? " + (run.hasPassword ? "Yes" : "No")}</div>
                {
                    runStatus != "Complete" && run.reportLink != undefined && run.reportLink != null && run.reportLink != "" ? null : (
                        <a href={run.reportLink}>
                            <div className={"download-button"}
                            //onClick={this.openDownloadLink.bind(null, run.reportLink)}
                            >{"Download"}</div>
                        </a>
                    )
                }
                {
                    runStatus === "Pending" ? null : (
                        <div className={"download-button"} onClick={this.popRerunForm.bind(null, run)}>{"Re-Run"}</div>
                    )
                }
                <div className={"download-button red"} onClick={this.deleteRun.bind(null, run.reportRunId)}>{"Delete"}</div>
                {emailJsx}
            </div>
        ));
    }

    deleteRun(reportRunId) {
        let self = this;

        zconfirm("Are you sure you want to delete this run?", () => {
            self.props.loadingOn();
            self.reportingService.deleteRun(reportRunId, () => {
                let report = self.state.activeReport;
                self.reportingService.getRuns(
                    report.reportId,
                    self.state.accountInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].companyID,
                    runs => {
                        report.runs = runs;
                        self.setState({ activeReport: report, newRunForm: null, newRunFinisherForm: null, newPhase: 0, emailDeleteIndex: null }, () => {
                            window.hideAlert();
                            self.props.loadingOff();
                        });
                    }, err => {
                        self.props.loadingOff();
                    });
            }, err => {
                self.props.loadingOff();
            })
        })

    }

    generateNewRunForm() {
        let self = this;

        let formFields = [];
        let metaData = this.state.activeReport.metaData;
        metaData = _.sortBy(metaData, x => x.Sequence);
        metaData.forEach(meta => {
            let selectorComponent = null;
            switch (meta.FieldType) {
                case "MultiSelect":
                    selectorComponent = (
                        <ZMultiSelector
                            key={"multi-selector-" + meta.Name}
                            id={"multi-selector-" + meta.Name}
                            className={""}
                            placeholder={meta.Name}
                            multiDisplay={"Multi"}
                            menuItems={meta.GenericGetResults != undefined && meta.GenericGetResults != null ?
                                meta.GenericGetResults :
                                meta.JsonData.reduce((r, e) => { r.push({ key: e.Key, value: e.Value }); return r }, [])}
                            displayProperty={"key"}
                            valueProperty={"value"}
                            values={self.state.newRunForm[meta.Name]}
                            onChange={self.editNewRunForm.bind(null, meta)}
                            toggleAll={this.toggleAllNewRunForm.bind(null, meta.Name)}
                            setGenericSelectorJsx={this.setGenericSelectorJsx}
                        />
                    )
                    break;
                case "DateTime":
                    let todayDate = new Date();
                    todayDate.setHours(12);
                    selectorComponent = (
                        <DatePicker
                            id={"date-picker-" + meta.Name}
                            className={"new-run-datepicker"}
                            label={null}
                            inline
                            defaultValue={todayDate}
                            displayMode={"portrait"}
                            fullWidth={true}
                            formatOptions={{
                                year: '2-digit',
                                month: '2-digit',
                                day: '2-digit'
                            }}
                            //maxDate={todayDate}
                            minDate={new Date('01/01/2000')}
                            onChange={this.editNewRunFormDate.bind(null, meta)}
                        />
                    )
                    break;
                case "DropDownList":
                    let menuItems = [];
                    if (meta.JsonData != undefined) {
                        menuItems = meta.JsonData.reduce((r, e) => { r.push({ key: e.Key, value: e.Value }); return r }, []);
                    } else if (meta.GenericGetResults != undefined) {
                        menuItems = meta.GenericGetResults;
                    }
                    selectorComponent = (
                        <ZSingleSelector
                            id={"single-selector-" + meta.Name}
                            className={""}
                            placeholder={meta.Name}
                            multiDisplay={"Multi"}
                            menuItems={menuItems}
                            displayProperty={"key"}
                            valueProperty={"value"}
                            value={self.state.newRunForm[meta.Name]}
                            onChange={self.editNewRunForm.bind(null, meta)}
                            toggleAll={this.toggleAllNewRunForm.bind(null, meta.Name)}
                            setGenericSelectorJsx={this.setGenericSelectorJsx}
                        />
                    )
                    break;
            }
            formFields.push((
                <div className={"run-field-outer"}>
                    <div className={"title"}>{meta.DisplayName}</div>
                    {selectorComponent}
                </div>
            ));
        });

        return (<div className={"new-report-run-outer"}>{formFields}</div>);
    }

    generateNewRunFinisherForm() {
        let formFields = [];

        let newRunFinisherForm = this.state.newRunFinisherForm;

        formFields.push((
            <div className={"run-field-outer"}>
                <div className={"title"}>{"Report expires in..."}</div>
                <SelectField
                    id={"expire-select-field"}
                    label={""}
                    placeholder={"Expires In"}
                    className={"md-cell run-drop"}
                    menuItems={["1 Day", "1 Week", "2 Weeks", "1 Month", "3 Months", "6 Months", "1 Year"]}
                    simplifiedMenu={true}
                    value={newRunFinisherForm.expireDate}
                    onChange={this.editNewRunFinisherForm.bind(null, "expireDate")}
                />
            </div>
        ));

        let locationMenuItems = [];
        if (this.state.newRunForm.Companies != undefined) {
            locationMenuItems = this.state.accountInfo.clientAccountList.reduce((r, e) => {
                if (this.state.newRunForm.Companies.includes(e.companyID + "")) {
                    e.locations.forEach(loc => {
                        if (loc.status.statusId === 1) {
                            r.push({ key: loc.name, value: loc.locationID });
                        }
                    });
                }

                return r;
            }, [])
        } else {
            this.state.accountInfo.clientAccountList[zzDataCache.settings.selectedClientAccountIndex].locations.forEach(loc => {
                if (loc.status.statusId === 1) {
                    locationMenuItems.push({ key: loc.name, value: loc.locationID });
                }
            });
        }

        locationMenuItems = _.sortBy(locationMenuItems, x => x.key.toUpperCase().trim());

        formFields.push((
            <div className={"run-field-outer"}>
                <div className={"title"}>{"Please select locations"}</div>
                <ZMultiSelector
                    id={"multi-selector-locids"}
                    className={""}
                    placeholder={"Locations"}
                    multiDisplay={"Multi"}
                    menuItems={locationMenuItems}
                    displayProperty={"key"}
                    valueProperty={"value"}
                    values={this.state.newRunFinisherForm.locationIds}
                    onChange={this.editNewRunFinisherForm.bind(null, "locationIds")}
                    toggleAll={this.toggleAllNewRunFinisherForm.bind(null, "locationIds")}
                    setGenericSelectorJsx={this.setGenericSelectorJsx}
                />
            </div>
        ));

        formFields.push((
            <div className={"run-field-outer"}>
                <div className={"title"}>{"User permission level"}</div>
                <div className={"user-type-selector-outer"}>
                    <div className={"user-type-button" + (newRunFinisherForm.userTypeId === 1 ? " active" : "")}
                        onClick={this.editNewRunFinisherForm.bind(null, "userTypeId", 1)}>{"1"}</div>
                    <div className={"user-type-button" + (newRunFinisherForm.userTypeId === 2 ? " active" : "")}
                        onClick={this.editNewRunFinisherForm.bind(null, "userTypeId", 2)}>{"2"}</div>
                    <div className={"user-type-button" + (newRunFinisherForm.userTypeId === 3 ? " active" : "")}
                        onClick={this.editNewRunFinisherForm.bind(null, "userTypeId", 3)}>{"3"}</div>
                    <div className={"user-type-button" + (newRunFinisherForm.userTypeId === 4 ? " active" : "")}
                        onClick={this.editNewRunFinisherForm.bind(null, "userTypeId", 4)}>{"4"}</div>
                    <div className={"user-type-button" + (newRunFinisherForm.userTypeId === 5 ? " active" : "")}
                        onClick={this.editNewRunFinisherForm.bind(null, "userTypeId", 5)}>{"5"}</div>
                </div>
                <div className={"user-type-permission-description-container"}>
                    <div className={"description" + (newRunFinisherForm.userTypeId === 0 ? " active" : "")}>{"ZeeZor Staff"}</div>
                    <div className={"description" + (newRunFinisherForm.userTypeId === 1 ? " active" : "")}>{"Owners"}</div>
                    <div className={"description" + (newRunFinisherForm.userTypeId === 2 ? " active" : "")}>{"Region Managers"}</div>
                    <div className={"description" + (newRunFinisherForm.userTypeId === 3 ? " active" : "")}>{"District Managers"}</div>
                    <div className={"description" + (newRunFinisherForm.userTypeId === 4 ? " active" : "")}>{"Location Managers"}</div>
                    <div className={"description" + (newRunFinisherForm.userTypeId === 5 ? " active" : "")}>{"Employees"}</div>
                </div>
            </div>
        ));

        formFields.push((
            <div className={"run-field-outer"}>
                <div className={"title"}>{"Password (Optional)"}</div>
                <TextField
                    id={"password-textfield"}
                    placeholder={"No Password"}
                    className={"password-text-input"}
                    value={newRunFinisherForm.password}
                    onChange={this.editNewRunFinisherForm.bind(null, "password")}
                />
            </div>
        ));

        formFields.push((
            <div className={"run-field-outer"}>
                <div className={"title"}>{"Include password in emails?"}</div>
                <div className={"user-type-selector-outer"}>
                    <div className={"user-type-button fifty" + (!newRunFinisherForm.includePasswordInEmail ? " active" : "")}
                        onClick={this.editNewRunFinisherForm.bind(null, "includePasswordInEmail", false)}>{"No"}</div>
                    <div className={"user-type-button fifty" + (newRunFinisherForm.includePasswordInEmail ? " active" : "")}
                        onClick={this.editNewRunFinisherForm.bind(null, "includePasswordInEmail", true)}>{"Yes"}</div>
                </div>
            </div>
        ));


        let emailListJsx = [];
        for (var i = 0; i < newRunFinisherForm.sendToEmails.length; i++) {
            let index = i;
            emailListJsx.push((
                <div key={newRunFinisherForm.sendToEmails[i].key} className={"email-container" + (this.state.emailDeleteIndex === i ? " deleted" : "")}>
                    <TextField
                        id={"email-textfield-" + i}
                        placeholder={"johndoe@somewhere.com"}
                        className={"password-text-input email-text-input"}
                        value={newRunFinisherForm.sendToEmails[i].value}
                        onChange={this.editNewRunFinisherFormEmail.bind(null, i)}
                        onBlur={() => {
                            if (newRunFinisherForm.sendToEmails.length > 1 && newRunFinisherForm.sendToEmails[index].value === "") {
                                this.removeFinisherEmail(index);
                            }
                        }}
                    />
                    <div className={"material-icons email-add-close-icon"} onClick={this.removeFinisherEmail.bind(null, i)}>{"add"}</div>
                </div>
            ));
        }

        let lastEmail = newRunFinisherForm.sendToEmails[newRunFinisherForm.sendToEmails.length - 1];
        let isAddButtonHidden = lastEmail != undefined && lastEmail.value === "";
        emailListJsx.push((
            <div key={"email-no-" + (this.emailKeyIncrementor + 1)} className={"email-container add-mode" + (isAddButtonHidden ? " hidden" : "")}>
                <TextField
                    id={"email-textfield-" + newRunFinisherForm.sendToEmails.length}
                    placeholder={"johndoe@somewhere.com"}
                    className={"password-text-input email-text-input"}
                    value={""}
                    onChange={() => { }}
                />
                <div className={"material-icons email-add-close-icon"} onClick={this.addFinisherEmail}>{"add"}</div>
            </div>
        ));
        formFields.push((
            <div className={"run-field-outer"}>
                <div className={"title"}>{"Emails to send results"}</div>
                <div className={"email-list-outer"}>
                    {emailListJsx}
                </div>
            </div>
        ));


        return (<div className={"new-report-run-outer"}>{formFields}</div>)
    }

    generateRerunForm() {
        let formFields = [];

        let rerunForm = this.state.rerunForm;

        formFields.push((
            <div className={"run-field-outer"}>
                <div className={"title"}>{"Report expires in..."}</div>
                <SelectField
                    id={"expire-select-field"}
                    label={""}
                    placeholder={"Expires In"}
                    className={"md-cell run-drop"}
                    menuItems={["1 Day", "1 Week", "2 Weeks", "1 Month", "3 Months", "6 Months", "1 Year"]}
                    simplifiedMenu={true}
                    value={rerunForm.expireDate}
                    onChange={this.editRerunForm.bind(null, "expireDate")}
                />
            </div>
        ));

        formFields.push((
            <div className={"run-field-outer"}>
                <div className={"title"}>{"Password (Optional)"}</div>
                <TextField
                    id={"password-textfield"}
                    placeholder={"No Password"}
                    className={"password-text-input"}
                    value={rerunForm.password}
                    onChange={this.editRerunForm.bind(null, "password")}
                />
            </div>
        ));

        formFields.push((
            <div className={"run-field-outer"}>
                <div className={"title"}>{"Include password in emails?"}</div>
                <div className={"user-type-selector-outer"}>
                    <div className={"user-type-button fifty" + (!rerunForm.includePasswordInEmail ? " active" : "")}
                        onClick={this.editRerunForm.bind(null, "includePasswordInEmail", false)}>{"No"}</div>
                    <div className={"user-type-button fifty" + (rerunForm.includePasswordInEmail ? " active" : "")}
                        onClick={this.editRerunForm.bind(null, "includePasswordInEmail", true)}>{"Yes"}</div>
                </div>
            </div>
        ));


        let emailListJsx = [];
        for (var i = 0; i < rerunForm.sendToEmails.length; i++) {
            let index = i;
            emailListJsx.push((
                <div key={rerunForm.sendToEmails[i].key} className={"email-container" + (this.state.emailDeleteIndex === i ? " deleted" : "")}>
                    <TextField
                        id={"email-textfield-" + i}
                        placeholder={"johndoe@somewhere.com"}
                        className={"password-text-input email-text-input"}
                        value={rerunForm.sendToEmails[i].value}
                        onChange={this.editRerunFormEmail.bind(null, i)}
                        onBlur={() => {
                            if (rerunForm.sendToEmails.length > 1 && rerunForm.sendToEmails[index].value === "") {
                                this.removeFinisherEmail(index);
                            }
                        }}
                    />
                    <div className={"material-icons email-add-close-icon"} onClick={this.removeRerunEmail.bind(null, i)}>{"add"}</div>
                </div>
            ));
        }

        let lastEmail = rerunForm.sendToEmails[rerunForm.sendToEmails.length - 1];
        let isAddButtonHidden = lastEmail != undefined && lastEmail.value === "";
        emailListJsx.push((
            <div key={"email-no-" + (this.emailKeyIncrementor + 1)} className={"email-container add-mode" + (isAddButtonHidden ? " hidden" : "")}>
                <TextField
                    id={"email-textfield-" + rerunForm.sendToEmails.length}
                    placeholder={"johndoe@somewhere.com"}
                    className={"password-text-input email-text-input"}
                    value={""}
                    onChange={() => { }}
                />
                <div className={"material-icons email-add-close-icon"} onClick={this.addRerunEmail}>{"add"}</div>
            </div>
        ));
        formFields.push((
            <div className={"run-field-outer"}>
                <div className={"title"}>{"Emails to send results"}</div>
                <div className={"email-list-outer"}>
                    {emailListJsx}
                </div>
            </div>
        ));


        return (<div className={"new-report-run-outer"}>{formFields}</div>)
    }

    openDownloadLink(reportLink) {
        if (cordova) {
            cordova.InAppBrowser.open(reportLink, '_blank', 'location=no', 'disallowoverscroll=no', 'toolbar=yes', 'closebuttoncaption=done');
        } else {
            window.open(reportLink, '_blank', 'location=no', 'disallowoverscroll=no', 'toolbar=yes', 'closebuttoncaption=done');
        }
    }

    setGenericSelectorJsx(jsx) {
        this.setState({ genericSelectorJsx: jsx });
    }

    render() {

        let newFormJsx = null;
        let newFormFinisherJsx = null;
        if (this.state.newPhase > 0) {
            newFormJsx = this.generateNewRunForm();
            newFormFinisherJsx = this.generateNewRunFinisherForm();
        }
        let rerunFormJsx = null;
        if (this.state.rerunPhase > 0) {
            rerunFormJsx = this.generateRerunForm();
        }

        let runDialogClass = "";
        if (usingiOS && zMedia.isPhone()) {
            runDialogClass = "iosmode";
        }

        return (
            <div id="page-outer">
                <ReportingTopBar
                    mode={this.state.mode}
                    toggleNav={this.props.toggleNav}
                    back={this.back}
                />
                <ReportingViewCentral
                    mode={this.state.mode}
                    reportList={this.state.reportList}
                    activeReport={this.state.activeReport}
                    openReport={this.openReport}
                    popNewReport={this.popNewReport}
                    showRunInfo={this.showRunInfo}
                />
                <DialogContainer
                    id="new-run-dialog-container"
                    className={runDialogClass}
                    visible={this.state.newPhase === 1}
                    title={""}
                    onHide={() => { this.setState({ newRunForm: null, newRunFinisherForm: null, newPhase: 0, emailDeleteIndex: null }) }}
                    actions={[
                        <Button flat secondary onClick={() => { this.setState({ newRunForm: null, newRunFinisherForm: null, newPhase: 0, emailDeleteIndex: null }) }}>{"Cancel"}</Button>
                        ,
                        <Button flat primary onClick={this.goToNewRunFinisher}>{"Next"}</Button>
                    ]}
                >
                    <div className="alert-message">{newFormJsx}</div>
                </DialogContainer>
                <DialogContainer
                    id="new-run-finisher-dialog-container"
                    className={runDialogClass}
                    visible={this.state.newPhase === 2}
                    title={""}
                    onHide={() => { this.setState({ newPhase: 1 }) }}
                    actions={[
                        <Button flat secondary onClick={() => { this.setState({ newPhase: 1 }) }}>{"Back"}</Button>
                        ,
                        <Button flat primary onClick={this.submitForm}>{"Run"}</Button>
                    ]}
                >
                    <div className="alert-message">{newFormFinisherJsx}</div>
                </DialogContainer>
                <DialogContainer
                    id="rerun-dialog-container"
                    className={runDialogClass}
                    visible={this.state.rerunPhase === 1}
                    title={""}
                    onHide={() => { this.setState({ rerunPhase: 0, rerunForm: null, emailDeleteIndex: null }) }}
                    actions={[
                        <Button flat secondary onClick={() => { this.setState({ rerunPhase: 0, rerunForm: null, emailDeleteIndex: null }) }}>{"Cancel"}</Button>
                        ,
                        <Button flat primary onClick={this.submitRerunForm}>{"Run"}</Button>
                    ]}
                >
                    <div className="alert-message">{rerunFormJsx}</div>
                </DialogContainer>
                <div className={"generic-selector-container " + (this.state.genericSelectorJsx === null ? " disabled" : "")}>
                    {this.state.genericSelectorJsx}
                </div>
            </div>
        )
    }
}